import React from 'react'
import { Message } from '@paypalcorp/worldready-react'
import { hasTreatmentName } from '../utils'

const interestMarketingConfig = [
  {
    sectionName: <Message id="interestMarketing.interestTitle" />,
    isEnabled: true,
    enabledCountries: [],
    hasElmoTreatment: true,
    subSections: [
      {
        title: <Message id="interestMarketing.marketingPayPal.title" />,
        desc: <Message id="interestMarketing.marketingPayPal.desc" />,
        iconName: 'logo-paypal',
        linkClass: 'nemo-subSection-header subSection-header',
        hasElmoTreatment: true,
        featureEnabled: true,
        navigateTo: hasTreatmentName(
          'Trmt_Interest_Based_Marketing_DataPrivacy',
        )
          ? '/myaccount/privacy/settings/personalization/paypal'
          : '/myaccount/settings/personalization/paypal?hide-menu=true',
        fptiClickData: {
          pgrp: 'main:dataprivacy:home',
          page: 'main:dataprivacy:home',
          link: 'marketing_on_pp',
        },
      },
      {
        title: <Message id="interestMarketing.marketingAccount.title" />,
        desc: <Message id="interestMarketing.marketingAccount.desc" />,
        iconName: 'desktop',
        linkClass: 'nemo-subSection-header subSection-header',
        hasElmoTreatment: true,
        featureEnabled: true,
        navigateTo: hasTreatmentName(
          'Trmt_Interest_Based_Marketing_DataPrivacy',
        )
          ? '/myaccount/privacy/settings/personalization/other'
          : '/myaccount/settings/personalization/other?hide-menu=true',
        fptiClickData: {
          pgrp: 'main:dataprivacy:home',
          page: 'main:dataprivacy:home',
          link: 'marketing_on_others',
        },
      },
    ],
  },
]

export default interestMarketingConfig
